import Vue from 'vue'
import Vuex from 'vuex'

import {categories} from './categories'
import {quartiers} from './quartiers'
import {types} from './types'
import {departements} from './departements'
import {formepharmacetiques} from './formepharmacetiques'
import {assureurs} from './assureurs'
import {tiers} from './tiers'
import {pharmacies} from './pharmacies'
import {userspharmacies} from './userspharmacies'
import {roleusers} from './roleusers'
import {tiersassureurs} from './tiersassureurs'
import {blogs} from './blogs'
import {roles} from './roles'
import {balance} from './balance'
import {balance_stories} from './balance_stories'
import {ask_payouts} from './ask_payouts'
import {users} from './users'
import {auth} from './auth'
import {produits} from './produits'
import {pharmaproduits} from "./pharmaproduits";
import {historiques} from "./historiques";
import {uploads} from "./uploads";
import {precommandes} from "./precommandes";



Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
      categories:categories,
      quartiers:quartiers,
      types:types,
      departements:departements,
      formepharmacetiques:formepharmacetiques,
      assureurs:assureurs,
      ask_payouts:ask_payouts,
      tiersassureurs:tiersassureurs,
      tiers:tiers,
      pharmacies:pharmacies,
      blogs:blogs,
      roles:roles,
      roleusers:roleusers,
      userspharmacies:userspharmacies,
      balance:balance,
      balance_stories:balance_stories,
      users:users,
      auth:auth,
      pharmaproduits:pharmaproduits,
      historiques:historiques,
      uploads:uploads,
      produits:produits                                                                                                         ,
      precommandes:precommandes                                                                                                         ,
  }
})
